import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './shared/layout/layout.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AuthGuard } from './auth/auth.guard';
import { AuthlayoutComponent } from './shared/authlayout/authlayout.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { TabLayoutComponent } from './shared/tab-layout/tab-layout.component';
import { CanDeactivateGuard } from './guard/can-component-deactivate.guard';
import { LevelComponent } from './pages/resources/level/level.component';
import { LevelFormComponent } from './pages/resources/level/level-form/level-form.component';
import { ProgramsComponent } from './pages/resources/programs/programs.component';
import { ProgramFormComponent } from './pages/resources/programs/program-form/program-form.component';
import { LessonComponent } from './pages/resources/lesson/lesson.component';
import { LessonFormComponent } from './pages/resources/lesson/lesson-form/lesson-form.component';
import { TrainingModuleComponent } from './pages/resources/training-module/training-module.component';
import { TrainingActivityComponent } from './pages/resources/training-activity/training-activity.component';
import { TrainingSkillComponent } from './pages/resources/training-module/training-skill/training-skill.component';
import { SentenceCompletionComponent } from './pages/resources/training-module/sentence-completion/sentence-completion.component';
import { TrainingModuleFormComponent } from './pages/resources/training-module/training-module-form/training-module-form.component';
import { SentenceCompletionListeningComponent } from './pages/resources/training-module/sentence-completion-listening/sentence-completion-listening.component';
import { SentenceCompletionGrammarComponent } from './pages/resources/training-module/sentence-completion-grammar/sentence-completion-grammar.component';
import { KeyVocabularyComponent } from './pages/resources/key-vocabulary/key-vocabulary.component';
import { GrammarComponent } from './pages/resources/grammar/grammar.component';
import { PictureDescriptionComponent } from './pages/resources/picture-description/picture-description.component';
import { MultipleChoiceQuestionComponent } from './pages/resources/multiple-choice-question/multiple-choice-question.component';
import { ConversationComponent } from './pages/resources/conversation/conversation.component';
import { WordPronunciationComponent } from './pages/resources/word-pronunciation/word-pronunciation.component';
import { SentencePronunciationComponent } from './pages/resources/sentence-pronunciation/sentence-pronunciation.component';
import { MatchingExerciseComponent } from './pages/resources/matching-exercise/matching-exercise.component';
import { MatchingExerciseListeningComponent } from './pages/resources/matching-exercise/matching-exercise-listening/matching-exercise-listening.component';
import { MatchingExerciseGrammarComponent } from './pages/resources/matching-exercise/matching-exercise-grammar/matching-exercise-grammar.component';
import { WordClassComponent } from './pages/resources/word-class/word-class.component';
import { WordClassGrammarComponent } from './pages/resources/word-class/word-class-grammar/word-class-grammar.component';
import { RewordingComponent } from './pages/resources/rewording/rewording.component';
import { SenteceStructureComponent } from './pages/resources/sentece-structure/sentece-structure.component';
import { DictationComponent } from './pages/resources/dictation/dictation.component';
import { HangmanComponent } from './pages/resources/hangman/hangman.component';
import { MultipleChoiceQuestionGrammarComponent } from './pages/resources/multiple-choice-question/multiple-choice-question-grammar/multiple-choice-question-grammar.component';
import { MultipleChoiceQuestionListeningComponent } from './pages/resources/multiple-choice-question/multiple-choice-question-listening/multiple-choice-question-listening.component';
import { CommonMistakesComponent } from './pages/resources/common-mistakes/common-mistakes.component';
import { InterestingArticleComponent } from './pages/resources/interesting-article/interesting-article.component';
import { ShortStoryComponent } from './pages/resources/short-story/short-story.component';
import { TongueTwisterComponent } from './pages/resources/tongue-twister/tongue-twister.component';
import { BookstoreComponent } from './pages/bookstore/bookstore.component';
import { TrendingComponent } from './pages/bookstore/trending/trending.component';
import { TrendingFormComponent } from './pages/bookstore/trending/trending-form/trending-form.component';
import { GenresComponent } from './pages/bookstore/genres/genres.component';
import { BooksComponent } from './pages/bookstore/books/books.component';
import { BookFormComponent } from './pages/bookstore/books/book-form/book-form.component';
import { SectionsComponent } from './pages/bookstore/sections/sections.component';
import { SectionsFormComponent } from './pages/bookstore/sections/sections-form/sections-form.component';
import { GenresFormComponent } from './pages/bookstore/genres/genres-form/genres-form.component';
import { PublisherComponent } from './pages/bookstore/publisher/publisher.component';
import { PublisherFormComponent } from './pages/bookstore/publisher/publisher-form/publisher-form.component';
import { AuthorComponent } from './pages/bookstore/author/author.component';
import { AuthorFormComponent } from './pages/bookstore/author/author-form/author-form.component';
import { SlidesComponent } from './pages/bookstore/slides/slides.component';
import { SlideFormComponent } from './pages/bookstore/slides/slide-form/slide-form.component';
import { ProgramLevelComponent } from './pages/resources/programs/program-level/program-level.component';
import { DictionaryPageComponent } from './pages/dictionary/dictionary.component';
import { DictionaryFormComponent } from './pages/dictionary/dictionary-form/dictionary-form.component';
import { ProgramLevelLessonComponent } from './pages/resources/programs/program-level-lesson/program-level-lesson.component';
import { ProgramLevelLessonModuleComponent } from './pages/resources/programs/program-level-lesson-module/program-level-lesson-module.component';
import { DictionaryDetailComponent } from './pages/dictionary/dictionary-detail/dictionary-detail.component';
import { EnrollmentComponent } from './pages/enrollment/enrollment.component';
import { StudentsComponent } from './pages/enrollment/students/students.component';
import { StudentFormComponent } from './pages/enrollment/students/student-form/student-form.component';
import { GrammarInUseComponent } from './pages/resources/grammar-in-use/grammar-in-use.component';
import { GrammarSectionFormComponent } from './pages/resources/grammar-in-use/grammar-section-form/grammar-section-form.component';
import { GrammarSectionComponent } from './pages/resources/grammar-in-use/grammar-section/grammar-section.component';
import { GrammarLessonComponent } from './pages/resources/grammar-in-use/grammar-lesson/grammar-lesson.component';
import { GrammarLessonFormComponent } from './pages/resources/grammar-in-use/grammar-lesson-form/grammar-lesson-form.component';
import { GrammarContentFormComponent } from './pages/resources/grammar-in-use/grammar-content-form/grammar-content-form.component';
import { GrammarInUseExerciseComponent } from './pages/resources/grammar-in-use/grammar-in-use-exercise/grammar-in-use-exercise.component';
import { GrammarInUseExerciseFormComponent } from './pages/resources/grammar-in-use/grammar-in-use-exercise-form/grammar-in-use-exercise-form.component';
import { PlacementTestComponent } from './pages/testing-center/placement-test/placement-test.component';
import { PlacementVocabularyComponent } from './pages/testing-center/placement-test/placement-vocabulary/placement-vocabulary.component';
import { PlacementGrammarComponent } from './pages/testing-center/placement-test/placement-grammar/placement-grammar.component';
import { PlacementListeningComponent } from './pages/testing-center/placement-test/placement-listening/placement-listening.component';
import { PlacementReadingComponent } from './pages/testing-center/placement-test/placement-reading/placement-reading.component';
import { PlacementGrammarFormComponent } from './pages/testing-center/placement-test/placement-grammar-form/placement-grammar-form.component';
import { PlacementListeningFormComponent } from './pages/testing-center/placement-test/placement-listening-form/placement-listening-form.component';
import { PlacementReadingFormComponent } from './pages/testing-center/placement-test/placement-reading-form/placement-reading-form.component';
import { NgsPlacementTestComponent } from './pages/testing-center/ngs-placement-test/ngs-placement-test.component';
import { NgsPlacementFormComponent } from './pages/testing-center/ngs-placement-test/ngs-placement-form/ngs-placement-form.component';
import { MathPlacementComponent } from './pages/testing-center/ngs-placement-test/math-placement/math-placement.component';
import { McqGeneralPlacementComponent } from './pages/testing-center/ngs-placement-test/mcq-general-placement/mcq-general-placement.component';
import { BookClubComponent } from './pages/book-club/book-club.component';
import { MaterialBookClubComponent } from './pages/book-club/material-book-club/material-book-club.component';
import { ExerciseBookClubComponent } from './pages/book-club/exercise-book-club/exercise-book-club.component';
import { TutorComponent } from './pages/enrollment/tutor/tutor.component';
import { TutorFormComponent } from './pages/enrollment/tutor/tutor-form/tutor-form.component';
import { ClassroomComponent } from './pages/enrollment/classroom/classroom.component';
import { RegisterTestComponent } from './pages/enrollment/register-test/register-test.component';
import { FacultyComponent } from './pages/list/faculty/faculty.component';
import { CurriculumCourseComponent } from './pages/list/faculty/curriculum-course/curriculum-course.component';
import { FacultyPanelComponent } from './pages/list/faculty/faculty-panel/faculty-panel.component';
import { FacultyOverviewComponent } from './pages/list/faculty/faculty-overview/faculty-overview.component';
import { MajorComponent } from './pages/list/faculty/major/major.component';
import { CurriculaComponent } from './pages/list/faculty/curricula/curricula.component';
import { CONFIG } from './dummy/app';
import { CurriculumComponent } from './pages/list/faculty/curriculum/curriculum.component';
import { RouteLayoutComponent } from './shared/route-layout/route-layout.component';
import { RoomComponent } from './pages/list/room/room.component';
import { BuildingComponent } from './pages/list/building/building.component';
import { FloorComponent } from './pages/list/floor/floor.component';
import { CampusComponent } from './pages/list/campus/campus.component';
import { RoomTypesComponent } from './pages/list/room-types/room-types.component';
import { TermComponent } from './pages/list/shift/term/term.component';
import { SubjectComponent } from './pages/list/subject/subject.component';
import { ShiftComponent } from './pages/list/shift/shift.component';
import { SessionComponent } from './pages/list/shift/session/session.component';
import { LecturersComponent } from './pages/list/lecturers/lecturers.component';
import { TuitionFeeComponent } from './pages/list/tuition-fee/tuition-fee.component';
import { TrainingProgramComponent } from './pages/list/training-program/training-program.component';
import { DegreeComponent } from './pages/list/degree/degree.component';
import { GeoDataComponent } from './pages/list/geo-data/geo-data.component';
import { GeoProvinceComponent } from './pages/list/geo-data/geo-province/geo-province.component';
import { GeoDistrictComponent } from './pages/list/geo-data/geo-district/geo-district.component';
import { GeoAnalyticsComponent } from './pages/list/geo-data/geo-analytics/geo-analytics.component';
import { SettingComponent } from './pages/list/setting/setting.component';
import { NationalityComponent } from './pages/list/nationality/nationality.component';
import { HolidayComponent } from './pages/list/holiday/holiday.component';
import { LectureTypeComponent } from './pages/list/lecture-type/lecture-type.component';
import { CourseTypeComponent } from './pages/list/course-type/course-type.component';
import { ADProgramsComponent } from './pages/list/programs/programs.component';
import { ADLevelComponent } from './pages/list/level/level.component';
import { AddNewTestingComponent } from './components/add-new-testing/add-new-testing.component';
import { ClassroomPanelComponent } from './pages/enrollment/classroom/classroom-panel/classroom-panel.component';
import { ClassroomStudentComponent } from './pages/enrollment/classroom/classroom-student/classroom-student.component';
import { AchievementTestComponent } from './pages/testing-center/achievement-test/achievement-test.component';
import { ProgramAchievementTestComponent } from './pages/resources/programs/program-achievement-test/program-achievement-test.component';
import { ProgramReadingComponent } from './pages/resources/programs/program-reading/program-reading.component';
import { ProgramAchievementTestVocabularyComponent } from './pages/resources/programs/program-achievement-test-vocabulary/program-achievement-test-vocabulary.component';
import { ProgramAchievementTestListeningComponent } from './pages/resources/programs/program-achievement-test-listening/program-achievement-test-listening.component';
import { ProgramAchievementTestReadingComponent } from './pages/resources/programs/program-achievement-test-reading/program-achievement-test-reading.component';
import { ProgramAchievementTestGrammarComponent } from './pages/resources/programs/program-achievement-test-grammar/program-achievement-test-grammar.component';
import { RegisterTestFormComponent } from './pages/enrollment/register-test-form/register-test-form.component';
import { AdmissionComponent } from './pages/enrollment/admission/admission.component';
import { ScheduleComponent } from './pages/enrollment/schedule/schedule.component';
import { EnrollReadingComponent } from './pages/enrollment/enroll-reading/enroll-reading.component';
import { ReadingClubComponent } from './pages/reading-club/reading-club.component';
import { ReadingLevelComponent } from './pages/reading-club/reading-level/reading-level.component';
import { ReadingFormatComponent } from './pages/reading-club/reading-format/reading-format.component';
import { ReadingTypeComponent } from './pages/reading-club/reading-type/reading-type.component';
import { ReadingTargetAgeComponent } from './pages/reading-club/reading-target-age/reading-target-age.component';
import { AddReadingAudioBookComponent } from './pages/reading-club/add-reading-audio-book/add-reading-audio-book.component';
import { AppSlideComponent } from './pages/app-center/app-slide/app-slide.component';
import { AppVideoComponent } from './pages/app-center/app-video/app-video.component';
import { TrainingStudentComponent } from './pages/training/training-student/training-student.component';
import { TrainingTutorComponent } from './pages/training/training-tutor/training-tutor.component';
import { TrainingBatchesComponent } from './pages/training/training-batches/training-batches.component';
import { TrainingTrailAccountComponent } from './pages/training/training-trail-account/training-trail-account.component';
import { TrainingSupportComponent } from './pages/training/training-support/training-support.component';
import { TrainingRegisterTestComponent } from './pages/training/training-register-test/training-register-test.component';
import { NewAndTrendingComponent } from './pages/bookstore/new-and-trending/new-and-trending.component';
import { ReadingUserComponent } from './pages/reading-club/reading-user/reading-user.component';
import { ReadingBatchComponent } from './pages/reading-club/reading-batch/reading-batch.component';
import { ReadingBatchLevelComponent } from './pages/reading-club/reading-batch-level/reading-batch-level.component';
import { ReadingBatchLevelStudentComponent } from './pages/reading-club/reading-batch-level-student/reading-batch-level-student.component';
import { SchoolsComponent } from './pages/reading-club/schools/schools.component';
import { IntroductionDialogueComponent } from './pages/resources/introduction-dialogue/introduction-dialogue.component';
import { PictureDescriptionSpeakingComponent } from './pages/resources/picture-description-speaking/picture-description-speaking.component';
import { ImportCamReadingStudentComponent } from './pages/reading-club/import-cam-reading-student/import-cam-reading-student.component';
import { AcademicYearComponent } from './pages/reading-club/academic-year/academic-year.component';
import { ResolveDataComponent } from './pages/reading-club/resolve-data/resolve-data.component';

const routes: Routes = [
  {
    path: "login",
    component: AuthlayoutComponent,
    children: [
      { path: "", component: LoginComponent },
    ]
  },
  {
    path: "",
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "reading-batches", component: TabLayoutComponent, children: [
          { path: "", redirectTo: "batches", pathMatch: "full" },
          {
            path: "batches", component: ReadingBatchComponent, children: [
              { path: ":id", component: ReadingBatchLevelStudentComponent },
            ]
          },
        ]
      },
      {
        path: "year", component: TabLayoutComponent, children: [
          { path: "", redirectTo: "data", pathMatch: "full" },
          { path: "data", component: AcademicYearComponent },
        ]
      },

      {
        path: "resolve-data", component: TabLayoutComponent, children: [
          { path: "", redirectTo: "data", pathMatch: "full" },
          { path: "data", component: ResolveDataComponent },
        ]
      },
      {
        path: "members", component: TabLayoutComponent, children: [
          { path: "", redirectTo: "students", pathMatch: "full" },
          { path: ":id", component: ReadingUserComponent },
        ]
      },
      {
        path: "schools", component: TabLayoutComponent, children: [
          { path: "", redirectTo: "data", pathMatch: "full" },
          { path: "data", component: SchoolsComponent },
        ]
      },
      {
        path: "import-cam-reading-student", component: TabLayoutComponent, children: [
          { path: "", redirectTo: "data", pathMatch: "full" },
          { path: "data", component: ImportCamReadingStudentComponent },
        ]
      },
      {
        path: "app-center", component: TabLayoutComponent, children: [
          { path: "", redirectTo: "submitted", pathMatch: "full" },
          { path: ":id", component: AppSlideComponent },
          { path: "books/:id", component: NewAndTrendingComponent },
          { path: "demo/videos", component: AppVideoComponent },
        ]
      },
      { path: "", component: DashboardComponent, pathMatch: "full" },
      {
        path: "enrollment", component: TabLayoutComponent,
        children: [
          { path: "", redirectTo: "dashboard", pathMatch: "full" },
          { path: "dashboard", component: EnrollmentComponent },
          {
            path: "students", component: TabLayoutComponent, children: [
              { path: "", redirectTo: "submitted", pathMatch: "full" },
              { path: ":id", component: StudentsComponent },
              { path: "admission/:id", component: StudentFormComponent },
            ]
          },
          {
            path: "register-test", component: TabLayoutComponent, children: [
              { path: "", redirectTo: "submitted", pathMatch: "full" },
              { path: ":id", component: RegisterTestComponent },
              { path: "form/:id", component: RegisterTestFormComponent },
            ]
          },

          {
            path: "classrooms", component: TabLayoutComponent, children: [
              { path: "", redirectTo: "submitted", pathMatch: "full" },
              { path: ":id", component: ClassroomComponent },
              {
                path: ":id/panel", component: ClassroomPanelComponent, children: [
                  { path: "", redirectTo: "students", pathMatch: "full" },
                  { path: "students", component: ClassroomStudentComponent },
                  { path: "schedules", component: ScheduleComponent },
                  { path: "reading", component: EnrollReadingComponent },
                ]
              },
            ]
          },
          {
            path: "tutors", component: TabLayoutComponent, children: [
              { path: "", redirectTo: "submitted", pathMatch: "full" },
              { path: ":id", component: TutorComponent },
              { path: "admission/:id", component: TutorFormComponent },
            ]
          },
          {
            path: "admissions", component: TabLayoutComponent, children: [
              { path: "", redirectTo: "submitted", pathMatch: "full" },
              { path: ":id", component: AdmissionComponent },
              { path: "form/:id", component: TutorFormComponent },
            ]
          },
        ]
      },
      {
        path: "book-club", component: TabLayoutComponent,
        children: [
          { path: "", redirectTo: "general-knowledge", pathMatch: "full" },
          { path: "general-knowledge", component: BookClubComponent },
          { path: "material/:id", component: MaterialBookClubComponent },
          { path: "exercise/:id/:classKey/:exerciseKey", component: ExerciseBookClubComponent },
        ]
      },
      {
        path: "audio-reading", component: TabLayoutComponent,
        children: [
          { path: "", redirectTo: "library", pathMatch: "full" },
          { path: "library", component: ReadingClubComponent },
          { path: "library/:typeKey/:id", component: AddReadingAudioBookComponent },

          { path: "level", component: ReadingLevelComponent },
          { path: "format", component: ReadingFormatComponent },
          { path: "target-age", component: ReadingTargetAgeComponent },
          { path: "type", component: ReadingTypeComponent },
        ]
      },
      {
        path: "book-store", component: TabLayoutComponent,
        children: [
          { path: "", redirectTo: "books/submitted", pathMatch: "full" },
          { path: "levels", component: ReadingBatchLevelComponent },
          { path: "books/:id", component: BooksComponent },
          { path: "library/:typeKey/:id", component: AddReadingAudioBookComponent },
          {
            path: "trending", component: TabLayoutComponent, children: [
              { path: "", redirectTo: "submitted", pathMatch: "full" },
              { path: ":id", component: TrendingComponent },
              { path: "data/:id", component: TrendingFormComponent },
            ]
          },
          {
            path: "genres", component: TabLayoutComponent, children: [
              { path: "", redirectTo: "submitted", pathMatch: "full" },
              { path: ":id", component: GenresComponent },
              { path: "data/:id", component: GenresFormComponent },
            ]
          },
          {
            path: "sections", component: TabLayoutComponent, children: [
              { path: "", redirectTo: "submitted", pathMatch: "full" },
              { path: ":id", component: SectionsComponent },
              { path: "data/:id", component: SectionsFormComponent },
            ]
          },
          {
            path: "publisher", component: TabLayoutComponent, children: [
              { path: "", redirectTo: "submitted", pathMatch: "full" },
              { path: ":id", component: PublisherComponent },
              { path: "publisher-form/:id", component: PublisherFormComponent },
            ]
          },
          {
            path: "author", component: TabLayoutComponent, children: [
              { path: "", redirectTo: "submitted", pathMatch: "full" },
              { path: ":id", component: AuthorComponent },
              { path: "author-form/:id", component: AuthorFormComponent },
            ]
          },
          {
            path: "books", component: TabLayoutComponent, children: [
              { path: "", redirectTo: "submitted", pathMatch: "full" },
              { path: ":id", component: BooksComponent },
              { path: "data/:id", component: BookFormComponent },
              { path: "data/:typeKey/:id/exercise", component: ExerciseBookClubComponent },
            ]
          },
          {
            path: "slides", component: TabLayoutComponent, children: [
              { path: "", redirectTo: "submitted", pathMatch: "full" },
              { path: ":id", component: SlidesComponent },
              { path: "slide-form/:id", component: SlideFormComponent },
            ]
          },
        ]
      },
      {
        path: "testing-center/general-placement-test", component: TabLayoutComponent,
        children: [
          { path: "", redirectTo: "classes", pathMatch: "full" },
          { path: "classes", component: NgsPlacementTestComponent },
          { path: ":skillKey/:id", component: MathPlacementComponent },
          { path: ":skillKey/:id/:key", component: McqGeneralPlacementComponent },
        ]
      },
      {
        path: "testing-center/placement-test", component: TabLayoutComponent,
        children: [
          { path: "", redirectTo: "vocabulary/vocabulary_pi", pathMatch: "full" },
          { path: "vocabulary/:id", component: PlacementTestComponent },
          { path: "vocabulary/:id/:key", component: PlacementVocabularyComponent },

          { path: "grammar/:id", component: PlacementGrammarComponent },
          { path: "grammar/:id/:key", component: PlacementGrammarFormComponent },

          { path: "listening/:id", component: PlacementListeningComponent },
          { path: "listening/:id/:key", component: PlacementListeningFormComponent },
          { path: "reading/:id", component: PlacementReadingComponent },
          { path: "reading/:id/:key", component: PlacementReadingFormComponent },
        ]
      },

      {
        path: "programs", component: TabLayoutComponent,
        children: [
          { path: "", redirectTo: "submitted", pathMatch: "full" },
          { path: ":id", component: ProgramsComponent },
          { path: "program-form/:id", component: ProgramFormComponent },
          { path: ":id/program", component: ProgramLevelComponent },
          { path: ":programKey/:id/level", component: ProgramLevelLessonComponent },
          { path: ":programKey/:id/:testingType", component: ProgramAchievementTestComponent },

          { path: ":programKey/:levelKey/reading", component: ProgramReadingComponent },
          { path: ":programKey/:levelKey/:lessonKey/module", component: ProgramLevelLessonModuleComponent },
        ]
      },
      {
        path: "levels", component: TabLayoutComponent,
        children: [
          { path: "", redirectTo: "submitted", pathMatch: "full" },
          { path: ":id", component: LevelComponent },
          { path: "level-form/:id", component: LevelFormComponent },
        ]
      },
      {
        path: "lessons", component: TabLayoutComponent,
        children: [
          { path: "", redirectTo: "submitted", pathMatch: "full" },
          { path: ":id", component: LessonComponent },
          { path: "lesson-form/:id", component: LessonFormComponent },
        ]
      },

      {
        path: "training", component: TabLayoutComponent,
        children: [
          { path: "", redirectTo: "students", pathMatch: "full" },
          { path: "students", component: TrainingStudentComponent },
          { path: "tutors", component: TrainingTutorComponent },
          { path: "batches/:id", component: TrainingBatchesComponent },
          { path: "trail-accounts", component: TrainingTrailAccountComponent },
          { path: "support", component: TrainingSupportComponent },
          { path: "register-test", component: TrainingRegisterTestComponent },
        ]
      },


      {
        path: "grammar-in-use", component: TabLayoutComponent,
        children: [
          { path: "", redirectTo: "submitted", pathMatch: "full" },
          { path: ":id", component: GrammarInUseComponent },
          { path: "lesson/:id", component: GrammarLessonComponent },
          { path: "section/:lessonKey/:id", component: GrammarSectionComponent },
          { path: "grammar-in-use-lesson/:id", component: GrammarLessonFormComponent },
          { path: "grammar-in-use-section/:lessonKey/:id", component: GrammarSectionFormComponent },
          { path: "content/:lessonKey/:sectionKey/:id", component: GrammarContentFormComponent },
          { path: "exercises/:lessonKey/:id", component: GrammarInUseExerciseComponent },
          { path: "exercises/:lessonKey/:sectionKey/:id", component: GrammarInUseExerciseFormComponent },
        ]
      },

      {
        path: "modules", component: TabLayoutComponent,
        children: [
          { path: "", redirectTo: "submitted", pathMatch: "full" },
          { path: ":id", component: TrainingModuleComponent },
          { path: "submitted/:id/lesson", component: TrainingSkillComponent },
          { path: ":lessonKey/form/:id", component: TrainingModuleFormComponent },
          {
            path: "activities", component: TabLayoutComponent, children: [
              { path: ':code/:id', component: TrainingActivityComponent }
            ]
          },
          {
            path: "activity-type/picture_description/vocabulary", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: PictureDescriptionComponent }
            ]
          },
          {
            path: "activity-type/picture_description_speaking/speaking", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: PictureDescriptionSpeakingComponent }
            ]
          },
          {
            path: "activity-type/grammar/grammar", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: GrammarComponent }
            ]
          },
          {
            path: "activity-type/sentence_completion/reading", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: SentenceCompletionComponent }
            ]
          },
          {
            path: "activity-type/sentence_completion/listening", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: SentenceCompletionListeningComponent }
            ]
          },
          {
            path: "activity-type/sentence_completion/grammar", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: SentenceCompletionGrammarComponent }
            ]
          },
          {
            path: "activity-type/key_vocabulary/vocabulary", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: KeyVocabularyComponent }
            ]
          },
          {
            path: "activity-type/multiple_choice/reading", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: MultipleChoiceQuestionComponent }
            ]
          },
          {
            path: "activity-type/multiple_choice/listening", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: MultipleChoiceQuestionListeningComponent }
            ]
          },
          {
            path: "activity-type/multiple_choice/grammar", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: MultipleChoiceQuestionGrammarComponent }
            ]
          },
          {
            path: "activity-type/introduction_dialogue/listening", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: IntroductionDialogueComponent }
            ]
          },
          {
            path: "activity-type/conversation/speaking", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: ConversationComponent }
            ]
          },
          {
            path: "activity-type/matching_exercise/reading", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: MatchingExerciseComponent }
            ]
          },
          {
            path: "activity-type/matching_exercise/listening", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: MatchingExerciseListeningComponent }
            ]
          },
          {
            path: "activity-type/matching_exercise/grammar", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: MatchingExerciseGrammarComponent }
            ]
          },
          {
            path: "activity-type/word_pronunciation/speaking", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: WordPronunciationComponent }
            ]
          },
          {
            path: "activity-type/sentence_pronunciation/speaking", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: SentencePronunciationComponent }
            ]
          },
          {
            path: "activity-type/word_class/vocabulary", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: WordClassComponent }
            ]
          },
          {
            path: "activity-type/word_class/grammar", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: WordClassGrammarComponent }
            ]
          },
          {
            path: "activity-type/rewording/grammar", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: RewordingComponent }
            ]
          },
          {
            path: "activity-type/sentece_structure/grammar", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: SenteceStructureComponent }
            ]
          },
          {
            path: "activity-type/dictation/listening", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: DictationComponent }
            ]
          },
          {
            path: "activity-type/dictation/vocabulary", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: DictationComponent }
            ]
          },
          {
            path: "activity-type/hangman/vocabulary", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: HangmanComponent }
            ]
          },
          {
            path: "activity-type/common_mistakes/vocabulary", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: CommonMistakesComponent }
            ]
          },
          {
            path: "activity-type/interesting_article/reading", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: InterestingArticleComponent }
            ]
          },
          {
            path: "activity-type/short_story/reading", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: ShortStoryComponent }
            ]
          },
          {
            path: "activity-type/tongue_twister/speaking", component: TabLayoutComponent, children: [
              { path: ':MODULE_KEY/:id', component: TongueTwisterComponent }
            ]
          },


        ]
      },
      {
        path: "activities", component: TabLayoutComponent,
        children: [
          { path: "", redirectTo: "draft", pathMatch: "full" },
          { path: ":id", component: TrainingActivityComponent },
          { path: "activity-form/:id", component: LessonFormComponent },
        ]
      },

      {
        path: "user-management", component: TabLayoutComponent,
        children: [

        ]
      },
      {
        path: "dictionary", component: TabLayoutComponent,
        children: [
          { path: "", redirectTo: "draft", pathMatch: "full" },
          { path: ':id', component: DictionaryPageComponent },
          { path: 'detail/:id', component: DictionaryDetailComponent },
          { path: 'dictionary-form/:id', component: DictionaryFormComponent },
        ]
      },
      {
        path: "faculties", component: RouteLayoutComponent, children: [
          { path: "", redirectTo: "data", pathMatch: "full" },
          { path: ":id", component: FacultyComponent },
          { path: "curriculum/:id", component: CurriculumCourseComponent },
          {
            path: "selected/:id", component: FacultyPanelComponent, children: [
              { path: "", redirectTo: "overview", pathMatch: "full" },
              { path: "overview", component: FacultyOverviewComponent },
              { path: "majors", component: MajorComponent },
              {
                path: "curricula", component: CurriculaComponent, children: [
                  { path: "", redirectTo: CONFIG.DEGREE, pathMatch: "full" },
                  { path: ":program", component: CurriculumComponent },
                ]
              },
            ]
          },
        ]
      },

      {
        path: "campus", component: RouteLayoutComponent, children: [
          { path: "", redirectTo: "rooms", pathMatch: "full" },
          { path: "rooms", component: RoomComponent },
          { path: "building", component: BuildingComponent },
          { path: "floor", component: FloorComponent },
          { path: "campus", component: CampusComponent },
          { path: "room-types", component: RoomTypesComponent },
        ]
      },
      {
        path: "terms", component: RouteLayoutComponent, children: [
          { path: "", redirectTo: "semester-term", pathMatch: "full" },
          { path: ":id", component: TermComponent },
        ]
      },
      {
        path: "subjects", component: RouteLayoutComponent, children: [
          { path: "", redirectTo: CONFIG.GPT, pathMatch: "full" },
          { path: ":id", component: SubjectComponent },
        ]
      },
      {
        path: "time-shift", component: RouteLayoutComponent, children: [
          { path: "", redirectTo: "shift", pathMatch: "full" },
          { path: "shift", component: ShiftComponent },
          { path: "session", component: SessionComponent },
        ]
      },
      {
        path: "lecturers", component: RouteLayoutComponent, children: [
          { path: "", redirectTo: "overview", pathMatch: "full" },
          { path: "overview", component: LecturersComponent },
        ]
      },
      {
        path: "tuition-and-service-fee", component: RouteLayoutComponent, children: [
          { path: "", redirectTo: CONFIG.FEE_PROGRAM, pathMatch: "full" },
          { path: ":id", component: TuitionFeeComponent },
        ]
      },
      {
        path: "education-system", component: RouteLayoutComponent, children: [
          { path: "", redirectTo: "programs", pathMatch: "full" },
          { path: "programs", component: ADProgramsComponent },
          { path: "programs/:id", component: TrainingProgramComponent },
          { path: "degree", component: DegreeComponent },
          { path: "level", component: ADLevelComponent },
        ]
      },
      {
        path: "geo", component: RouteLayoutComponent, children: [
          { path: "", redirectTo: "countries", pathMatch: "full" },
          { path: "countries", component: GeoDataComponent },
          { path: "provinces", component: GeoProvinceComponent },
          { path: "district", component: GeoDistrictComponent },
          { path: "analytics", component: GeoAnalyticsComponent },
        ]
      },
      {
        path: "settings", component: RouteLayoutComponent, children: [
          { path: "", redirectTo: "options", pathMatch: "full" },
          { path: "options", component: SettingComponent },
          { path: "nationality", component: NationalityComponent },
          { path: "holiday", component: HolidayComponent },
          { path: "lecturer-types", component: LectureTypeComponent },
          { path: "course-types", component: CourseTypeComponent },
        ]

      },
      { path: "add-new-testing", component: AddNewTestingComponent, },




    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    AuthGuard,
    CanDeactivateGuard
  ],
})
export class AppRoutingModule { }
